import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";

import { Microsoft } from "@/components/icons/microsoft";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { logger } from "@/lib/logger";

export function LoginPage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");

  const handleMicrosoftLogin = () => {
    logger.debug("[login] redirecting to Microsoft SSO");
    window.location.assign("/api/auth/sso/login");
  };

  useEffect(() => {
    const ssoError = searchParams.get("error");
    if (!ssoError) {
      return;
    }
    logger.debug("[login] sso error:", ssoError);
    setError(
      ssoError === "domain_not_allowed"
        ? "Your account's email domain isn't allowed to sign in."
        : "Sign-in failed. Please try again.",
    );
  }, [searchParams]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0E14] px-4">
      <Card className="w-full max-w-md overflow-hidden border-[#115cd3]/30 bg-[#1A1A2E]">
        <div className="flex justify-center bg-[#115cd3] py-8">
          <img src="/brand/norican-logo-white.svg" alt="Norican" className="h-10 w-auto" />
        </div>
        <CardContent className="pt-8 pb-8">
          <p className="mb-6 text-center text-sm text-[#9CA3A5]">Sign in to continue</p>

          <Button
            type="button"
            onClick={handleMicrosoftLogin}
            className="w-full bg-[#115cd3] text-white hover:bg-[#0e4aa9]"
          >
            <Microsoft className="size-4" />
            Sign in with Microsoft
          </Button>

          {error && <p className="mt-4 text-center text-sm text-[#EF4444]">{error}</p>}
        </CardContent>
      </Card>
    </div>
  );
}
